import React from "react";

const Tag = ({ text, type = "List" }) => {
  if (type == "Detail") {
    return (
      <div className="flex items-center justify-center py-2 px-2 gap-1 bg-white rounded border-gray-200 border">
        <span className="font-normal text-center text-[#757C7F] text-size-11 leading-3">
          {text}
        </span>
      </div>
    );
  }

  return (
    <>
      <div className="flex items-center justify-center py-1 px-2 gap-2.5 bg-white rounded">
        <span className="font-normal leading-normal text-center text-themeBlack text-size-11">
          {text}
        </span>
      </div>
    </>
  );
};

export default Tag;
